import { Box, Typography } from "@mui/material";

export default function Ratings() {
  return (
    <Box p={3}>
      <Typography variant="h4">Driver Ratings</Typography>
    </Box>
  );
}